// extracted by mini-css-extract-plugin
export default {"select":"style_select__N-+P5","active":"style_active__-VLz4","menu":"style_menu__Bhmy7","open":"style_open__SMogQ"};